export const route = {
    patterns: {
        talentDirectory: '/talent-directory',
    },
    searchParams: {
        searchTermParam: 'searchTerm',
        tabParam: 'tab',
    },
};
